import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrServiceLocal } from 'app/services/toast/toastr.service';
import { EstudianteFacadeService } from '../estudiante-facade.service';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { LoginFacadeService } from 'app/login/login-facade.service';

@Component({
  selector: 'app-cambio-credencial',
  templateUrl: './cambio-credencial.component.html',
  styleUrls: ['./cambio-credencial.component.css']
})
export class CambioCredencialComponent implements OnInit {
  changePasswordForm: FormGroup;
  showCurrentPassword = false;
  showNewPassword = false;
  showRepeatPassword = false;
  public loginForms: FormGroup;
  hide1: boolean = true;
  hide2: boolean = true; 
  hide3: boolean = true; 
  contraseñaNoIgual: boolean ;
  modalTitle: any;
  modalMessage: any;
  currentDialog: any;
  public logeoEmpleado: any = null;
  private subscriptions: Subscription = new Subscription();
  @ViewChild('Cambio') Cambio!: TemplateRef<any>;

  constructor(private fb: FormBuilder,private _router: Router, private _toast: ToastrServiceLocal,private EstudianteFacade: EstudianteFacadeService,public modal: MatDialog,public numberLogin: LoginFacadeService
    // public dialogRef: MatDialogRef<CambioCredencialComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string }
    ) {
    this.changePasswordForm = this.fb.group({
      anteriorPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      repeatPassword: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    // const shouldRedirect = localStorage.getItem('token-posgrado');
    // if (shouldRedirect === null) {
    //   this._router.navigateByUrl('/estudiante/login');
    // }
    const  logeoEmpleado  = this.numberLogin.getIdProgramacion();
    this.logeoEmpleado = logeoEmpleado
    console.log("logeoEmpleado",this.logeoEmpleado)
  }
 

  toggleHide1() {
    this.hide1 = !this.hide1;
  }

  toggleHide2() {
    this.hide2 = !this.hide2;
  }

  toggleHide3() {
    this.hide3 = !this.hide3;
  }


// Verifica si las contraseñas coinciden
get passwordsDoNotMatch(): boolean {
  const newPassword = this.changePasswordForm.get('newPassword')?.value;
  const repeatPassword = this.changePasswordForm.get('repeatPassword')?.value;
   
this.contraseñaNoIgual = newPassword && repeatPassword && newPassword !== repeatPassword
  return this.contraseñaNoIgual ;
}

// Método para enviar el formulario
onSubmit() {

  if (this.contraseñaNoIgual === false) {

    // OBTENGO valores del formulario
    const params = {
      anteriorPassword: this.changePasswordForm.value.anteriorPassword,
      newPassword: this.changePasswordForm.value.repeatPassword,
    };
    this.subscriptions.add(
      this.EstudianteFacade.cambioCredencialEstudiante(params).subscribe((response) => {
        this.subscriptions.add(
          this.EstudianteFacade.cambioContraseña$.subscribe((data) => {
            if (!response) {
              console.error('Error al cambiar la contraseña.');
            }
            data.forEach((asignatura) => {
              if (asignatura.codigo === 0) {
                try {
                  this._toast.mensajeSuccess('Contraseña cambiada exitosamente.', '');
                  this._router.navigateByUrl('/estudiante/login');
                  
                  // Abre el modal con el mensaje
                  this.abrirModal(this.Cambio);
                  localStorage.clear();
                  sessionStorage.clear();
              
                } catch (e) {
                  console.error('Error al cambiar la contraseña:', e);
                }
              }

              if(this.logeoEmpleado === 1){
                this._router.navigateByUrl('/inicio');
              }
            });
          })
        );
      })
    );


// // Llama al servicio
// this.EstudianteFacade.cambioCredencialEstudiante(params).subscribe({
//   next: (response) => {
//     if (response && response.success) {
//       this._toast.mensajeSuccess('Contraseña cambiada exitosamente.', '');
//       this._router.navigateByUrl('/estudiante/login');
//     } else {
//       this._toast.mensajeError(response.message || 'Error al cambiar la contraseña.', '');
//     }
//   }
//   // error: (err) => {
//   //   console.error('Error al cambiar la contraseña:', err);
//   //   this._toast.mensajeError('Ocurrió un error al procesar tu solicitud.', '');
//   // },
// });


  }else
  {
    this._toast.mensajeError('Tus nuevas credenciales no coinciden.', '');
  }
}
//  openModal(title: string, message: string) {
//   this.modalTitle = title;
//   this.modalMessage = message;
//   const screenWidth = window.innerWidth;
//   let modalWidth = screenWidth < 760 ? '90%' : '30%'; 
//   this.currentDialog  = this.modal.open(this.Cambio, {
   
//     width: modalWidth,
//    // Elimina restricciones de tamaño predeterminadas

//     panelClass: "app-full-bleed-dialog",
//     disableClose: true,
    
// });

// }


abrirModal(template: TemplateRef<any>): void {


  const screenWidth = window.innerWidth;
  // Establecer el ancho del modal según el tamaño de la pantalla
  let modalWidth = screenWidth < 760 ? '90%' : '40%'; 
   this.currentDialog  = this.modal.open(template, {
      width: modalWidth,
      panelClass: "app-full-bleed-dialog",
      disableClose: true,
  });

}
 
cerrarSesion() {
  localStorage.clear();
  sessionStorage.clear();
  this._router.navigateByUrl('/estudiante/login');
  if(this.logeoEmpleado === 1){
    this._router.navigateByUrl('/inicio');
  }
}

cerrarSesion1() {
  if (this.currentDialog) {
    this.currentDialog.close(); // Cerrar el modal
    localStorage.clear();
    sessionStorage.clear();
  }
  localStorage.clear();
  sessionStorage.clear();
  this._router.navigateByUrl('/estudiante/login');
  if(this.logeoEmpleado === 1){
    this._router.navigateByUrl('/inicio');
  }
}
}
